import React, { useState } from 'react'
import { DatePicker } from '@ublique/components/DatePicker'
import moment from 'moment'
import { first } from 'lodash'
import { OLDER_THAN } from '../constants'
import NumberInput from 'components/NumberInput'
import { useTranslation } from 'react-i18next'

const DATE_TIME_FORMAT = 'YYYY-MM-DD'
export const DEFAULT_LOCALE = 'en-GB'

function Date({ onChange, fieldValue, className, disabled, operator, t }) {
  const { i18n } = useTranslation()
  const lang = i18n.language ?? DEFAULT_LOCALE
  const locale = first(lang?.split('-'))
  const [number, setNumber] = useState()

  const handleOnChange = (e) => {
    const value = moment(first(e)).format(DATE_TIME_FORMAT)
    onChange({ params: { label: value, value: `'${value}'` } })
  }

  const onChangeNumber = (e) => {
    if (e !== number) {
      const num = e === '' ? 0 : e // default is 0
      setNumber(num)
      const value = num?.toString()
      onChange({
        params: { label: value, value },
        number: value,
        isTriggered: true,
        isNumberDate: true
      })
    }
  }

  if (operator.label === t(OLDER_THAN)) {
    return (
      <NumberInput
        className={`${className}-number`}
        labelText='Value'
        onChange={onChangeNumber}
        value={fieldValue.value}
        min={0}
      />
    )
  }

  return (
    <DatePicker
      dateFormat='d/m/Y'
      onChange={handleOnChange}
      datePickerType='single'
      value={fieldValue.value}
      locale={locale}
    >
      <DatePicker.Input
        className={`${className}-date`}
        disabled={disabled}
        labelText='Date'
        placeholder='yyyy/mm/dd'
      />
    </DatePicker>
  )
}

export default Date
